import { UserRegistrationModel } from './UserRegistrationModel';

export class SetPinModel extends UserRegistrationModel
{
    Pin : string
}